/* eslint-disable no-useless-computed-key */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState, useCallback, useRef } from 'react';
import customStyles from "../../../../../assets/styles/customStyles";
import MainHeader from "../../../../Shared/components/Header";
import SalesIcon from "../../../../../assets/images/icon_menus/SalesIcon.json";
import PrimaryCard from "../../../../Shared/components/Card/PrimaryCard";
import { Row, Col, Image, Space } from "antd";
import ImportIcon from "../../../../../assets/images/icon_actions/Import.svg";
import ExportIcon from "../../../../../assets/images/icon_actions/Export.svg";
import clsx from 'clsx';
//import FilterIcon from "../../../../../assets/images/icon_actions/Filter Icon.svg";
import { TextField } from "@mui/material";
import SearchIcon from "../../../../../assets/images/icon_actions/Search Icon.svg";
import ClearIcon from "../../../../../assets/images/icon_actions/Clear Icon.svg";
import { Link, useParams, NavLink } from "react-router-dom";
import AddIcon from "../../../../../assets/images/icon_actions/Add Icon.svg";
import { CustomerTable } from "./CustomerTable";
import { useDispatch, useSelector } from "react-redux";
import actions from "../../redux/actions";
import usePrevious from "../../../../Shared/components/Previous";
import crudActions from "../../../../CRUD/redux/actions";
import groupActions from "../../../Setup/redux/actions";
import { ImportExport } from '../../../../Shared/components/ImportExport';
import { checkViewPermission, checkCRUDPermission, checkComponentPermission, idNamingConversion } from '../../../../../helpers/utilities';
import { AutoCompleteComponent } from "../../../../Shared/components/AutoCompleteComponent";
import { useEventListener } from "../../../../../helpers/useEventListener";

const Customers = (props) => {
    const { roleManagement } = useSelector(state => state.authReducer);
    const { customerDetails, loader } = useSelector(state => state.salesManagementReducer);
    const { getList, getData } = useSelector(state => state.crudReducer);
    const { customerGroupdetails } = useSelector(state => state.salesSetupReducer);

    const dispatch = useDispatch();
    const { groupId } = useParams();
    const { history } = props;
    const [search, setSearch] = useState('');
    const [iconAnimation, setIconAnimation] = useState(false);
    const prevSearch = usePrevious(search);
    const [skip, setSkip] = useState(0);
    const timeoutRef = useRef(null);
    const limit = 25;
    const [loadMore, setLoadMore] = useState(false);
    const [loadMoreContent, setLoadMoreContent] = useState(false);
    const [sortOrder, setSortOrder] = useState("desc");
    const [sortBy, setSortBy] = useState("id");
    const [importVisible, setImportVisible] = useState(false);
    const [filterGroupId, setFilterGroupId] = useState(groupId || '');

    const handleOpen = () => {
    };

    useEffect(() => {
        if ((prevSearch !== undefined && search && search.length > 2 && prevSearch !== search) || (prevSearch !== undefined && search === '' && prevSearch !== search)) {
            if (timeoutRef.current !== null) {
                clearTimeout(timeoutRef.current);
            }
            if (search === '') {
                dispatchFilter(filterGroupId, sortBy, sortOrder);
            } else {
                timeoutRef.current = setTimeout(() => {
                    timeoutRef.current = null;
                    dispatchFilter(filterGroupId, sortBy, sortOrder);
                }, 500);
            }
        }
    }, [search]);

    useEffect(() => {
        if (roleManagement !== '') {
            if (checkViewPermission('All Customers', history, 'Sales')) {
                loadTasks();
            }
        }
    }, [roleManagement]);


    const handleKeyDown = (e) => {
        if ((e.altKey && e.keyCode === 78) || (navigator.platform.match("Mac") && e.ctrlKey && e.keyCode === 78)) {
            e.preventDefault();
            history.push('/sales/sales-management/all-customers/create');
        }
    };

    useEventListener("keydown", handleKeyDown);

    const prevGetData = usePrevious(getData);
    useEffect(() => {
        if (loadMore && getData === '') {
            setLoadMoreContent(false);
            setLoadMore(true);
        }
        if (prevGetData !== undefined && getData && prevGetData !== getData) {
            const timer = setTimeout(() => {
                if (getData && Array.isArray(getData) && getData.length > 0) {
                    setLoadMore(true);
                    if (getData.length < limit) {
                        setLoadMoreContent(false);
                    } else {
                        setLoadMoreContent(true);
                    }
                } else {
                    setLoadMoreContent(false);
                    setLoadMore(true);
                }
            });

            return () => {
                clearTimeout(timer);
            };
        }
    }, [getData]);

    const customObject = (details, id) => {
        let a = details && details.filter(function (el) { return el.id === id });
        if (a && a?.length !== 0) {
            return a[0];
        }
        return [];
    }

    const dispatchFilter = (filterGroupId, sortBy, sortOrder, skip = 0) => {
        if (skip === 0) {
            setLoadMore(false);
            setLoadMoreContent(false);
        }
        let filter = { ["and"]: [] };
        let or = { ["or"]: [] };

        if (search !== '') {
            or['or'].push({ name: { like: '%' + search.trim() + '%' } });
            or['or'].push({ serialNo: { like: '%' + search.trim() + '%' } });
            or['or'].push({ mobile: { like: '%' + search.trim() + '%' } });
            or['or'].push({ classification: { like: '%' + search.trim() + '%' } });
        }

        if (filterGroupId !== '') {
            filter['and'].push({ groupId: parseInt(filterGroupId) });
        }

        if (or.or.length > 0) {
            filter['and'].push(or);
        }
        setSkip(skip);
        dispatch({
            type: crudActions.GET_DETAILS_START,
            url: 'customerProfile',
            skip: skip,
            filter: {
                where: !filter.and || filter.and.length === 0 ? {} : filter,
                order: sortBy + ' ' + sortOrder,
                limit: limit,
                skip: skip,
            }
        });
    }

    const loadImportExportData = (name, data = 'existing', selected = [], extension = 'xlsx') => {
        dispatch({
            type: actions.CUSTOMER_DETAILS_START,
            export: name,
            data: data,
            selected: selected,
            extension: extension,
            url: 'customerProfile',
            filter: {
                order: sortBy + ' ' + sortOrder,
            }
        });
    }


    const loadTasks = useCallback(() => {
        dispatch({
            type: groupActions.CUSTOMERGROUP_DETAILS_START,
            url: 'customer-group',
            filter: {
                order: 'id desc '
            }
        });
        dispatchFilter(filterGroupId, sortBy, sortOrder);
    });

    const requestSort = (sortBy, sortOrder) => {
        setSortBy(sortBy);
        setSortOrder(sortOrder);
        dispatchFilter(filterGroupId, sortBy, sortOrder);
    }

    const loadMoreTask = () => {
        let s = skip + limit;
        dispatchFilter(filterGroupId, sortBy, sortOrder, s);
    }

    const classes = customStyles();
    return (
        <React.Fragment>
            <MainHeader
                {...props}
                closeLink={'/sales'}
                cls={'newImg'} img={SalesIcon} title={'Sales'}
                links={[{ 'label': 'Sales', 'link': '/sales' }, { 'label': 'All Customers', 'link': '' }]} />
            <div className={clsx(classes.margin40, classes.listTableMargin)}>
                <PrimaryCard
                    title={'All Customers'}
                    component={
                        <>
                            <Row align="middle" className={classes.marginBottom20}>
                                <Col xxl={6} xl={7} lg={8} md={10} sm={13} xs={24}>
                                    {
                                        roleManagement !== '' && checkComponentPermission('All Customers', 'Action', 'Search') &&
                                        <div className={clsx(classes.searchAnimation, { [classes.iconAnimation]: iconAnimation || search !== '' })}>
                                            <TextField autoComplete='one-time-code'
                                                placeholder='Search Name, ID, No., & Classification'
                                                type='search'
                                                fullWidth
                                                value={search}
                                                onChange={(e) => setSearch(e.target.value)}
                                                className={classes.comInput}
                                                variant={'standard'}
                                                id={idNamingConversion('search', 'customerProfile', 'TextField')}
                                                onFocus={() => setIconAnimation(true)}
                                                onBlur={() => setIconAnimation(false)}
                                            />
                                            <Image src={SearchIcon} preview={false} />
                                            {
                                                search && <NavLink to="#" onClick={() => setSearch('')} className={classes.searchClear}>
                                                    <Image
                                                        src={ClearIcon}
                                                        preview={false}
                                                    />
                                                </NavLink>
                                            }
                                        </div>
                                    }
                                </Col>
                                <Col xxl={18} xl={17} lg={16} md={14} sm={11} xs={24} className={clsx(classes.textAlignRight,
                                    classes.removeUnderline, classes.customerLabelNone, classes.vertiCalScrollOverFlowParent)}>
                                    <div className={classes.vertiCalScrollOverFlow}>
                                        <Space size={[20, 20]} direction="horizontal" align="center">
                                            {
                                                roleManagement !== '' && checkComponentPermission('All Customers', 'Action', 'Filter Group') &&
                                                <AutoCompleteComponent
                                                    customLabel={"All Group"}
                                                    heads={[{ 'key': 'name', 'name': 'Name' }, { 'key': 'description', 'name': 'Description' }]}
                                                    details={customerGroupdetails}
                                                    parentValue={customObject(customerGroupdetails, parseInt(filterGroupId))}
                                                    position={"bottom"}
                                                    name="All Group"
                                                    variant={'outlined'}
                                                    customClasses={clsx(classes.customWidth160P)}
                                                    id={idNamingConversion('search', 'customerProfile', 'DropDown')}
                                                    onChangeText={(data) => {
                                                        if (data === '') {
                                                            setFilterGroupId('');
                                                            dispatchFilter('', sortBy, sortOrder);
                                                        }
                                                    }}
                                                    onChange={(data) => {
                                                        setFilterGroupId(data.id) // help to set the value
                                                        dispatchFilter(data.id, sortBy, sortOrder);
                                                    }}
                                                />
                                            }
                                            {
                                                roleManagement !== '' && checkComponentPermission('All Customers', 'Action', 'Export') &&
                                                <NavLink
                                                    to="#"
                                                    id={idNamingConversion('Export', 'customerProfile', 'Link')}
                                                    onClick={() => { loadImportExportData('Customers'); }}
                                                    className={clsx(classes.customLink)}>
                                                    <Image
                                                        src={ExportIcon}
                                                        preview={false}
                                                        className={clsx(classes.antImage)}
                                                    /> <span className={clsx(classes.addLink, classes.color, classes.bold)}>Export</span>
                                                </NavLink>
                                            }
                                            {
                                                roleManagement !== '' && checkComponentPermission('All Customers', 'Action', 'Import') &&
                                                <NavLink
                                                    to="#"
                                                    id={idNamingConversion('Import', 'customerProfile', 'Link')}
                                                    onClick={() => { setImportVisible(true); }}
                                                    className={clsx(classes.customLink)}>
                                                    <Image
                                                        src={ImportIcon}
                                                        preview={false}
                                                        className={clsx(classes.antImage)}
                                                    /> <span className={clsx(classes.addLink, classes.color, classes.bold)}>Import</span>
                                                </NavLink>
                                            }
                                            {
                                                roleManagement !== '' && checkCRUDPermission('All Customers', 'create', 'Sales') &&
                                                <Link
                                                    to={`/sales/sales-management/all-customers/create`}
                                                    onClick={() => handleOpen()}
                                                    id={idNamingConversion('Add Customer', 'customerProfile', 'Link')}
                                                    className={clsx(classes.customLink)}
                                                >
                                                    <Image
                                                        src={AddIcon}
                                                        preview={false}
                                                        className={clsx(classes.antImage)}
                                                    /><span className={clsx(classes.addLink, classes.color, classes.bold)}>Add Customer</span>
                                                </Link>
                                            }
                                            {
                                                roleManagement !== '' && checkComponentPermission('All Customers', 'Action', 'Filter') &&
                                                <></>
                                            }
                                        </Space>
                                    </div>
                                </Col>
                            </Row>
                            <CustomerTable
                                search={search}
                                filterGroupId={filterGroupId}
                                loadTasks={() => dispatchFilter(filterGroupId, sortBy, sortOrder)}
                                details={getList}
                                loadMore={loadMore}
                                loadMoreTask={() => loadMoreTask()}
                                loadMoreContent={loadMoreContent}
                                roleManagement={roleManagement}
                                sortOrder={sortOrder}
                                sortBy={sortBy}
                                onRequestSort={(sortBy, sortOrder) => requestSort(sortBy, sortOrder)} />
                        </>
                    }
                />
            </div>
            <ImportExport
                handleClose={() => { setImportVisible(false); }}
                visible={importVisible}
                title={'Customers'}
                className={clsx(classes.closeBackGround, classes.width100P)}
                type={'import'}
                loader={loader}
                loadImportExportData={(name, type, selected, extension) => loadImportExportData(name, type, selected, extension)}
                details={customerDetails}
                loadTasks={() => { dispatchFilter(filterGroupId, sortBy, sortOrder) }}
            />
        </React.Fragment>
    )
}
export default Customers